<template>
  <router-view />
  <!-- Modale session expirée : token invalide, bouton Reconnecter vers /login -->
  <div v-if="tokenExpiredState.show" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Session expirée</h5>
        </div>
        <div class="modal-body">
          Votre session a expiré. Veuillez vous reconnecter pour continuer.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="goToLogin">Reconnecter</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="tokenExpiredState.show" class="modal-backdrop fade show"></div>
</template>

<script>
import { tokenExpiredState } from "@/services/tokenExpiredService";

export default {
  name: "app",
  data() {
    return {};
  },
  setup() {
    return { tokenExpiredState };
  },
  methods: {
    goToLogin() {
      tokenExpiredState.show = false;
      // Fermer la session Okta pour forcer une vraie reconnexion (sinon Okta garde la session et reconnecte tout seul)
      if (this.$auth) {
        this.$auth.revokeAccessToken();
        this.$auth.closeSession();
        this.$auth.tokenManager.clear();
      }
      sessionStorage.clear();
      localStorage.clear();
      this.$router.push("/login");
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

::placeholder {
    color: #6c757d !important;
  }

body {
    background: #f9f9f9; 
    /*background: #ffffff;*/
}

input[type="search"]::placeholder {
  color: #6c757d; /* Gris clair pour placeholder */
  font-style: italic; /* Style italique */
  font-size: smaller;
}

input[type="search"]:focus {
  border-color: #007bff; /* Bordure bleue au focus */
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); /* Effet d'ombre */
}

</style>
